import React, {
  useEffect, useState, useContext,
} from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import CustomBtn from '../../../../../../generic/CustomBtn';
import Loader from '../../../../../../components/Loader';
import CarbonFormDataProvider from '../CarbonFormDataProvider';
import { ReactComponent as TreeGroup } from '../../../../../../assets/image/carbon/tree-group.svg';
import './CarbonAvailable.scss';

import { getJSONFileFromIpfs, initIPFS } from '../../../../../../state/ipfs';
import { getContract, contractMethods } from '../../../../../../utils/near-utils';
import { appStore } from '../../../../../../state/app';

const CarbonAvailable = ({ projectData }) => {
  const translate = useIntl();
  const { state: { account } } = useContext(appStore);
  const { nameId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isFormOpened, setIsFormOpened] = useState(false);
  const [updProjectData, setUpdProjectData] = useState(structuredClone(projectData));

  const getContractProject = async () => {
    try {
      const ipfs = await initIPFS();
      const contract = getContract(account, contractMethods, 0);

      const token = await contract.get_project({ project_id: nameId });
      if (!token) return null;

      const projectCid = token.metadata.reference;
      const project = await getJSONFileFromIpfs(ipfs, projectCid);

      return project || null;
    } catch (e) {
      console.log(e);
      return null;
    }
  };

  const checkCarbonApplication = async () => {
    setIsLoading(true);

    // Get project from the smart-contract
    const contractProject = await getContractProject();

    /*
      Check if the carbon application is already exist
      Field "carbonApplication" is not null, If user has saved at least public or private data:

        1) Only private data exist
          {
            carbonApplication: {
              cid: '',
              completed: false,
              submittedAt: '',
            }
          }

        2) Only public OR public and private data exist, but it's not finalized
          {
            carbonApplication: {
              cid: '/ipfs/foobar',
              completed: false,
              submittedAt: '',
            }
          }

        3) Private and public data has been finalized (submitted)
           {
            carbonApplication: {
              cid: '/ipfs/foobar',
              completed: true,
              submittedAt: '1234567890',
            }
          }
    */
    const isApplicationStarted = !!contractProject?.carbonApplication;

    setIsFormOpened(isApplicationStarted);
    // Replace "carbonApplication" from indexer on "carbonApplication" from smart-contract
    // Data from smart-contract is up-to-date comparing to the delayed data from indexer
    setUpdProjectData((prev) => structuredClone({
      ...prev,
      ...(isApplicationStarted ? { carbonApplication: contractProject.carbonApplication } : null),
    }));
    setIsLoading(false);
  };

  const applyForCarbon = () => {
    setIsFormOpened(true);
  };

  useEffect(() => {
    checkCarbonApplication();
  }, []);

  if (isLoading) {
    return (
      <div className="carbon-available__loader-wrapper">
        <Loader />
      </div>
    );
  }

  if (isFormOpened) {
    return (
      <CarbonFormDataProvider
        projectData={updProjectData}
        initialTabKey=""
      />
    );
  }

  return (
    <div className="carbon-available">
      <p className="carbon-available__title">{translate.formatMessage({ id: 'carbon.available.financingIsAvailable' })}</p>
      <div className="carbon-available__image">
        <TreeGroup />
      </div>
      <div className="carbon-available__button-wrapper">
        <CustomBtn
          label={translate.formatMessage({ id: 'button-applyForCarbon' })}
          handleClick={() => applyForCarbon()}
          customClass="carbon-available__button"
        />
      </div>
    </div>
  );
};

export default CarbonAvailable;
